export default "assets/images/logo-communaute-gris-154ff203.png";